import { LANGUAGE_FROM_TOLGEE } from 'consts/languageFromTolgee'
import type { PrimaryLanguage, TEntityLanguages } from 'entities/languages'
import type { LocationLanguage } from 'lib/tolgee'

import { TAXONOMY_LANGUAGES_BY_KEY } from './consts'

const getTaxonomyLanguage = (language: TEntityLanguages) => {
  return TAXONOMY_LANGUAGES_BY_KEY[language]
}

const locationLanguageToPrimaryLanguage = (locationLanguage: LocationLanguage): PrimaryLanguage => {
  return (LANGUAGE_FROM_TOLGEE[locationLanguage] || 'por') as PrimaryLanguage
}

export default {
  getTaxonomyLanguage,
  locationLanguageToPrimaryLanguage,
}
